import React, { useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {

  const [menuOpen, setMenuOpen] = useState(false);
  const [serviceOpen, setServiceOpen] = useState(false);


  return (

    <header className="header">


      {/* LEFT LOGO */}
      <div className="logo-area">

        <div className="veg-icon">
          <span></span>
        </div>


        <Link to="/">
          <img
            src="/assets/img/logo/log.jpg"
            alt="logo"
          />
        </Link>

      </div>



      {/* RIGHT SIDE */}
      <div className="header-right">



        {/* TOP RED BAR */}

        <div className="top-bar">


          <div className="time">

            {/* <i className="fa-regular fa-clock"></i>

            10:00 am - 11:00 pm */}

          </div> 



          <div className="social">

            <span>
              Follow Us:
            </span>


              <a href="https://www.facebook.com/thespicerootcaterers/" target="_blank"><i className="fab fa-facebook-f"></i></a>
                    <a href="https://www.instagram.com/thespicerootcaterers/" target="_blank"><i className="fab fa-instagram"></i></a>
                    <a href="https://www.youtube.com/@thespicerootcaterers/" target="_blank"><i className="fa-brands fa-youtube"></i></a>

          </div>
        </div>

        {/* NAV BAR */}

        <div className="nav-bar">
          <div
            className="hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <i className="fas fa-bars"></i>
          </div>

          <nav className={menuOpen ? "open" : ""}>
            <ul>

              <li>
                <Link
                  to="/"
                  onClick={() => setMenuOpen(false)}
                >
                  Home
                </Link>
              </li>


              <li>
                <Link to="/about" onClick={() => setMenuOpen(false)}>
                  About Us
                </Link>
              </li>

              <li>
                <Link to="/menu" onClick={() => setMenuOpen(false)}>
                  Menu
                </Link>
              </li>

              {/* SERVICES */}

              <li
                className="services"
                onMouseEnter={() => setServiceOpen(true)}
                onMouseLeave={() => setServiceOpen(false)}
              >

                <span>
                  Services <small>▼</small>
                </span>
                <div className={`dropdown ${serviceOpen ? "show" : ""}`}>

                  <Link to="/service/catering">
                    🍽️

                    <div>
                      <b>Catering</b>
                      <small>
                        Food & beverage services
                      </small>
                    </div>

                  </Link>

                  <Link to="/service/decoration">
                    🎉
                    <div>
                      <b>Decoration</b>
                      <small>
                       Wedding & Event Decoration
                      </small>
                    </div>

                  </Link>

                  <Link to="/service/entertainment">
                    🎵
                    <div>
                      <b>Entertainment</b>
                      <small>
                       DJ, Music & Live Performances
                      </small>
                    </div>

                  </Link>

                  <Link to="/service/photography">
                    📷
                    <div>
                      <b>Photography</b>
                      <small>
                        Photo & Video Coverage
                      </small>
                    </div>
                  </Link>
                </div>
              </li>
              <li>
                <Link to="/gallery" onClick={() => setMenuOpen(false)}>
                  Gallery
                </Link>
              </li>

               <li>
                <Link to="/Pickyourdishes" onClick={() => setMenuOpen(false)}>
                Pick Your Dishes
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={() => setMenuOpen(false)}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>

  )

}


export default Header;